import { Link, Text, View } from "@react-pdf/renderer";

import { Logo } from "../assets/Logo";
import { styles } from "../styles";

export const PdfHeader = ({ title }: { title: string }) => (
  <View fixed style={styles.header}>
    <Link src="https://psychnow.com/chapter">
      <Logo width={78} height="auto" style={{ marginTop: 4 }} />
    </Link>
    <Text style={{ fontSize: 8, color: "#323539" }}>{title}</Text>
  </View>
);
